<template>
  <v-container fluid fill-height>
    <v-layout align-start justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Zmień hasło</v-toolbar-title>
          </v-toolbar>
          <form class="login" @submit.prevent="passwordChange" novalidate>
            <v-card-text>
            <Fields
              v-bind="{fields, object: formData, errors: formErrors}"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary">Ustaw nowe hasło</v-btn>
            </v-card-actions>
          </form>
          <v-progress-linear v-if="progress" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {passwordChange} from './api'
import iziToast from 'izitoast'
import Fields from '@/forms/Fields'

export default {
  components: {Fields},
  validators: {
  },
  data () {
    return {
      progress: false,
      formErrors: {},
      formData: {
      },
      error: false
    }
  },
  computed: {
    fields () {
      return [
        {comp: 'text', id: 'old_password', label: 'Obecne hasło', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'text', id: 'new_password1', label: 'Nowe hasło', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'text', id: 'new_password2', label: 'Powtórz nowe hasło', props: {type: 'password', prependIcon: 'lock'}}
      ]
    }
  },
  methods: {
    passwordChange () {
      this.$validate().then(success => {
        if (success) {
          this.progress = false
          passwordChange(this.formData).then((data) => {
            iziToast.show({
              message: 'Hasło zostało zmienione.',
              color: 'green'
            })
            this.formData = {}
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/ChangePassword.vue